    <!-- Sidebar -->
    <div class="col-md-3 col-lg-2 p-0 bg-dark-grey min-vh-100 position-md-fixed">
        <!-- Brand/logo -->
        <div class="d-flex justify-content-center py-3">
          <h4 class="text-white m-0">

            <a class="navbar-brand" routerLink="/">
              <img src="logo.png" alt="ICS.AI Logo">
            </a>

          </h4>
        </div>
        <!-- Navigation -->
        <ul class="nav flex-column pt-2">
          <li class="nav-item">
            <a class="nav-link text-white py-3 px-3" routerLink="/dashboard" routerLinkActive="bg-primary fw-bold">
              <i class="bi bi-speedometer2 me-2"></i>
              Dashboard
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white py-3 px-3" routerLink="/organizations" routerLinkActive="bg-primary fw-bold">
              <i class="bi bi-building me-2"></i>
              Organizations
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white py-3 px-3" routerLink="/organization-types" routerLinkActive="bg-primary fw-bold">
              <i class="bi bi-tags me-2"></i>
              Organization Types
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white py-3 px-3" routerLink="/organization-intent" routerLinkActive="bg-primary fw-bold">
              <i class="bi bi-building me-2"></i>
              <i class="bi bi-person me-2"></i>
              Organization-Intents
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white py-3 px-3" routerLink="/intents" routerLinkActive="bg-primary fw-bold">
              <i class="bi bi-person me-2"></i>
              Intents
            </a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link text-white py-3 px-3" routerLink="/analytics" routerLinkActive="bg-primary fw-bold">
              <i class="bi bi-graph-up me-2"></i>
              Analytics
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white py-3 px-3" routerLink="/settings" routerLinkActive="bg-primary fw-bold">
              <i class="bi bi-gear me-2"></i>
              Settings
            </a>
          </li> -->
        </ul>
      </div>
  